{
  "version": 1,
  "asset_id": "6bdcce2e-814a-437c-af89-a1798fe506ce",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/6bdcce2e-814a-437c-af89-a1798fe506ce/band-erosion-egd.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/6bdcce2e-814a-437c-af89-a1798fe506ce/band-erosion-egd.jpg",
  "original_filename": "band-erosion-egd.jpg",
  "size": 330099,
  "content_type": "image/jpeg",
  "created_at": "2026-11-02T10:46:10Z"
}
